import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getAuthorOrderHistory } from "../service";

export const useAuthorOrderHistory = (strategyId, options = {}) => {
  const { enabled = true, ...restOptions } = options;

  return useInfiniteQuery({
    queryKey: ["authorOrderHistory", strategyId],
    queryFn: ({ pageParam = 1 }) =>
      getAuthorOrderHistory(strategyId, { page: pageParam, size: 10 }),
    getNextPageParam: (lastPage) => {
      if (!lastPage?.page || !lastPage?.total_pages) return undefined;
      return lastPage.page < lastPage.total_pages
        ? lastPage.page + 1
        : undefined;
    },
    enabled: enabled && !!strategyId,
    ...restOptions,
  });
};
